import { useContext } from "react";
import { convertToTimeZone, formatToTimeZone } from "date-fns-timezone";
import AccountContext from "../account/AccountContext";
export var useLocalDate = function (date) {
    var timeZone = useContext(AccountContext).timeZone;
    return timeZone && date
        ? convertToTimeZone(new Date(date), { timeZone: timeZone })
        : undefined;
};
export var useLocalDateFormat = function (date, format) {
    if (format === void 0) { format = "MM/DD/YYYY hh:mm:ss A"; }
    var timeZone = useContext(AccountContext).timeZone;
    return timeZone && date
        ? formatToTimeZone(new Date(date), format, {
            timeZone: timeZone,
        })
        : undefined;
};
//# sourceMappingURL=useLocalDate.js.map